import React, {PureComponent} from 'react';
import {Container} from '@material-ui/core'
import Translation from './translation'
import Tracks from './tracks'
import Discovery from './discovery'
import AddTracks from './addTracks'
import {database} from "../logic/firebase";
import {updatePlayedTracks} from "../logic/api";

export default class AdminContainer extends PureComponent {

    constructor() {
        super();
        this.state = {
            currentTrack: null
        }
    }

    async componentDidMount() {
        this.getCurrentTrack();
        this.updatePlayed();
    }

    updatePlayed = () => {
        const playedRef = database().ref('/translation/playedTracks');
        playedRef.on('child_added', async () => {
            await updatePlayedTracks()
        });
        playedRef.on('child_removed', async () => {
            await updatePlayedTracks()
        })
    };

    getCurrentTrack = () => {
        const currentTrack = database().ref('/translation/currentTrack');
        currentTrack.on('value', (snapshot) =>
            this.setState({currentTrack: snapshot.val()})
        )
    };


    render() {
        const {currentTrack} = this.state;
        return (
            <Container style={{height: '100vh', paddingLeft: 0, paddingRight: 0}} maxWidth={false}>
                <div style={{height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <div style={{position:'relative', alignItems:'center',height: '100%', width:'100%', display: 'flex', flexDirection: 'column',justifyContent: 'center'}}>
                        <Discovery currentTrack={currentTrack}/>
                    </div>
                    <div style={{height: '100%',display: 'flex', flexDirection: 'column', width:'100%'}}>
                        <Translation/>
                        <AddTracks />
                        <Tracks currentTrack={currentTrack}/>
                    </div>
                </div>
            </Container>
        )
    }
}